export const content = `1. To stop receiving texts from BetterHelp, open your text conversation with BetterHelp on your phone.
2. Send a text with just the word **STOP**.
3. You’ll receive confirmation that you won’t get any more texts.
`;
